import React, { useState, useEffect } from "react";
import { Container, Offcanvas } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import logo from "../../image/sparkzlogo_bo.png";
import { Link, useLocation } from "react-router-dom";
import stocklogo from ".././../image/project/stocklogo.png";
import passlogo from ".././../image/project/passlogo.png";
import doclogo from ".././../image/project/doclogo.png";
import qmslogo from ".././../image/project/qmslogo.png";
import tracklogo from ".././../image/project/tracklogo.png";
import shuttlelogo from ".././../image/project/shuttlelogo.png";
import {
  FiChevronDown,
  FiMail,
  FiSettings,
  FiLayers,
  FiHome,
} from "react-icons/fi";
import {
  FaBoxes,
  FaFileAlt,
  FaIdBadge,
  FaClipboardCheck,
  FaMapMarkedAlt,
  FaBusAlt,
} from "react-icons/fa";

const Topheader = () => {
  const [show, setShow] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const toggleDropdown = (idx) => {
    setOpenDropdown(openDropdown === idx ? null : idx);
  };
  const toggleOffcanvas = () => setShow(!show);
  const closeOffcanvas = () => setShow(false);
  const [isShrunk, setIsShrunk] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const isDropdownActive = (dropdownItems = []) =>
    dropdownItems.some((item) => location.pathname.startsWith(item.path));
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setIsShrunk(currentScroll > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollTop]);
  return (
    <div
      className={`position-fixed top-0 start-50 translate-middle-x z-3 nav-pill-wrapper
        ${isShrunk ? "shrink" : ""}
      `}
    >
      <Container
        fluid
        className="d-flex justify-content-between align-items-center px-4 py-2 nav-pill-content"
      >
        <div>
          <Link to="home" smooth="easeInOutCubic" duration={600} offset={-70}>
            <img src={logo} className="logo" />
          </Link>
        </div>

        {/* Custom Toggle Button */}
        <button
          className="d-lg-none border-0 bg-transparent p-0"
          onClick={toggleOffcanvas}
          aria-label="Toggle navigation"
        >
          <FaBars className="fs-4 text-orange" />
        </button>

        {/* Offcanvas Menu */}
        <Offcanvas
          show={show}
          onHide={closeOffcanvas}
          placement="end"
          className="d-lg-none"
          style={{ width: "70vw" }}
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>

          <Offcanvas.Body className="px-2">
            <ul className="list-unstyled mb-0">
              {[
                {
                  href: "",
                  label: "Home",
                  icon: <FiHome className="icon" />,
                },
                {
                  href: "about",
                  label: "About Us",
                  icon: <FiSettings className="icon" />,
                },
                {
                  label: "Solution",
                  icon: <FiLayers className="icon" />,
                  hasDropdown: true,
                  items: [
                    {
                      label: "Intelistock",
                      icon: stocklogo,
                      path: "/solution/intelistock",
                    },
                    // {
                    //   label: "InteliDoc (ODMS)",
                    //   icon: (
                    //     <FaFileAlt size={15} className="text-primary me-2" />
                    //   ),
                    //   path: "/solution/intelidoc",
                    // },
                    {
                      label: "InteliPass",
                      icon: passlogo,
                      path: "/solution/intelipass",
                    },
                    {
                      label: "InteliQMS",
                      icon: qmslogo,
                      path: "/solution/inteliqms",
                    },
                    {
                      label: "InteliTrack",
                      icon: tracklogo,
                      path: "/solution/intelitrack",
                    },
                    {
                      label: "InteliShuttle",
                      icon: shuttlelogo,
                      path: "/solution/intelishuttle",
                    },
                    {
                      label: "InteliDoc",
                      icon: doclogo,
                      path: "/solution/intelidoc",
                    },
                  ],
                },
                {
                  href: "career",
                  label: "Career",
                  icon: <FiMail className="icon" />,
                },
                {
                  href: "contact",
                  label: "Contact Us",
                  icon: <FiMail className="icon" />,
                },
              ].map((item, idx) => (
                <li className="nav-item" key={idx}>
                  {item.hasDropdown ? (
                    <>
                      <button
                        className="nav-link-custom d-flex justify-content-between align-items-center w-100"
                        onClick={() => toggleDropdown(idx)}
                      >
                        <div className="d-flex align-items-center gap-2">
                          {item.icon}
                          {item.label}
                        </div>
                        <FiChevronDown
                          className={`dropdown-arrow ${
                            openDropdown === idx ? "rotated" : ""
                          }`}
                        />
                      </button>

                      <ul
                        className={`side-dropdown-menu-list ${
                          openDropdown === idx ? "open" : ""
                        }`}
                      >
                        {item.items.map((subItem, subIdx) => (
                          <li key={subIdx}>
                            <Link
                              to={subItem.path}
                              className="side-dropdown-link"
                              onClick={() => {
                                toggleDropdown("");
                                closeOffcanvas();
                              }}
                            >
                              <img
                                src={subItem.icon}
                                height="20px"
                                width="20px"
                                className="me-3"
                              />
                              {subItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      to={item.href}
                      className="nav-link-custom d-flex align-items-center gap-2"
                      onClick={closeOffcanvas}
                    >
                      {item.icon}
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Desktop Nav (visible on lg and up) */}

        <ul className="d-none d-lg-flex list-unstyled menu-nav gap-4 mb-0">
          {[
            { label: "Home", to: "/" },
            { label: "About", to: "/about" },
            {
              label: "Solutions",
              to: "projects",
              hasDropdown: true,
              dropdownItems: [
                {
                  label: "Intelistock",
                  icon: stocklogo,
                  path: "/solution/intelistock",
                },
                {
                  label: "InteliPass",
                  icon: passlogo,
                  path: "/solution/intelipass",
                },
                {
                  label: "InteliQMS",
                  icon: qmslogo,
                  path: "/solution/inteliqms",
                },
                {
                  label: "InteliTrack",
                  icon: tracklogo,
                  path: "/solution/intelitrack",
                },
                {
                  label: "InteliShuttle",
                  icon: shuttlelogo,
                  path: "/solution/intelishuttle",
                },
                {
                  label: "InteliDoc",
                  icon: doclogo,
                  path: "/solution/intelidoc",
                },
              ],
            },
            { label: "Career", to: "/career" },
            { label: "Contact", to: "/contact" },
          ].map((item, index) => (
            <li
              className={`position-relative ${
                item.hasDropdown ? "hover-dropdown" : ""
              }`}
              key={index}
            >
              {item.hasDropdown ? (
                <div
                  className={`d-flex align-items-center gap-1 top-nav-link-custom ${
                    isDropdownActive(item.dropdownItems) ? "active" : ""
                  }`}
                >
                  {item.label}
                  <FiChevronDown size={14} />
                </div>
              ) : (
                <Link
                  to={item.to}
                  className={`top-nav-link-custom ${
                    isActive(item.to) ? "active" : ""
                  }`}
                >
                  {item.label}
                </Link>
              )}

              {item.hasDropdown && (
                <ul className="hover-dropdown-menu">
                  {item.dropdownItems.map((drop, i) => (
                    <li key={i}>
                      <Link to={drop.path} className="dropdown-link">
                        <img
                          src={drop.icon}
                          height="20px"
                          width="20px"
                          className="me-3"
                        />
                        {drop.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};

export default Topheader;
